import { bool, string } from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import cn from 'classnames';

import { DATA_TEST_ID } from '~constants/tests';
import { CLIENT_PAGES } from '~constants/pages';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import iconUser from '~assets/icon-user.svg';

import { getMessage } from './utils';
import styles from './styles.module.scss';

const OpenLoginModalButton = ({ className, hasUserIcon, showWelcomeMessage = true }) => {
  const { currentUser } = useSelector((state) => state.auth);
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const { templateModel } = useSelector((state) => state.core);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleOpenLoginModal = () => {
    dispatch(ModalActions.openModal(MODALS.LOGIN));
  };

  const goToProfile = useCallback(() => history.push(CLIENT_PAGES.PROFILE.path), [history]);
  const message = useMemo(() => getMessage(currentUser, showWelcomeMessage), [
    currentUser,
    showWelcomeMessage
  ]);

  return (
    <button
      data-testid={DATA_TEST_ID.login}
      type="button"
      onClick={currentUser ? goToProfile : handleOpenLoginModal}
      className={className}>
      {hasUserIcon && (
        <img
          src={iconUser}
          className={cn('m-right-2', styles.userIcon, {
            [styles.secondaryHeader]: isSecondaryHeader,
            [styles.hidden]: !!currentUser
          })}
        />
      )}
      <span
        className={cn(`${styles[`text${templateModel}`]}`, {
          [styles.secondaryHeader]: isSecondaryHeader
        })}>
        {message}
      </span>
    </button>
  );
};

OpenLoginModalButton.propTypes = {
  className: string,
  hasUserIcon: bool,
  showWelcomeMessage: bool
};

export default OpenLoginModalButton;
